/**
 * Sends the page back to the top.
 *
 * `behavior` defaults to the smooth scroll the US store has always used. Pass
 * `"auto"` where the content underneath the scroll is being replaced at the
 * same time: a smooth scroll is still travelling when the new content lands,
 * and a page whose height changes mid-animation leaves the browser to clamp
 * the offset wherever it can, which strands the user part-way down the new
 * page instead of at the top of it.
 */
export const useScrollToTop = (behavior: ScrollBehavior = "smooth") => {
  return () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior,
    });
  };
};
